/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type WeekReportStatus = typeof WeekReportStatus[keyof typeof WeekReportStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WeekReportStatus = {
  DRAFT: 'DRAFT',
  IN_REVIEW: 'IN_REVIEW',
  SUBMITTED: 'SUBMITTED',
  UNDER_REVIEW: 'UNDER_REVIEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CORRECTED: 'CORRECTED',
  RESUBMITTED: 'RESUBMITTED',
} as const;
